import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { ReplaySubject } from 'rxjs';

import {
    ExtendedBaseProfileField,
    FieldReadHelper,
    PartialRecord,
    ShBaseGenericReadonlyFieldComponent,
    SuggestionMetadata,
    ThesaurusFieldValue
} from '@stylehaven/components';
import { MHSearchRoutingService } from '../../../../common/services/common/search-routing.service';

@Component({
    selector: 'med-thesaurus-readonly-field',
    templateUrl: './thesaurus-readonly-field.component.html',
    styleUrls: ['../readonly-base-style.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThesaurusReadonlyFieldComponent extends ShBaseGenericReadonlyFieldComponent implements OnDestroy {
    value$: ReplaySubject<ThesaurusFieldValue | null> = new ReplaySubject<ThesaurusFieldValue | null>(1);
    suggestion$: ReplaySubject<ThesaurusFieldValue | null> = new ReplaySubject<ThesaurusFieldValue | null>(1);

    constructor(
        protected fieldHelper: FieldReadHelper,
        protected searchRoutingService: MHSearchRoutingService
    ) {
        super(searchRoutingService);
    }

    init(profileField: ExtendedBaseProfileField, fragment: PartialRecord): void {
        const value: ThesaurusFieldValue = this.fieldHelper.getThesaurusFieldValue(
            profileField.FieldDefinition,
            fragment
        );

        if (!value && fragment.metadata.Context?.Suggestions) {
            const suggestion: SuggestionMetadata | undefined = fragment.metadata.Context.Suggestions.find(
                suggestion => suggestion.Structural.FieldDefinition.DottedKey === profileField.DottedKey
            );
            if (suggestion) {
                this.suggestion$.next(suggestion.Descriptive.Title as unknown as ThesaurusFieldValue);
                return;
            }
        }
        this.value$.next(value);
    }

    ngOnDestroy(): void {
        this.value$.complete();

        super.ngOnDestroy();
    }
}
